import React, { FC, useCallback } from 'react';

import DeleteButton from 'src/presentation/components/pages/shared/DeleteButton';
import { PaddedRowItem, StyledEntityRow, StyledRowItem, StyledTypeDescription } from '../shared/StyledComponents';

type ConditionRowProps = {
  className?: string;
  index: number;
  isReadOnly?: boolean;
  onDelete: Function;
  text?: string;
};

const ConditionRow: FC<ConditionRowProps> = ({ children, className, index, isReadOnly, onDelete, text }) => {
  const onClickDelete = useCallback(() => {
    onDelete(index);
  }, [index, onDelete]);

  return (
    <StyledEntityRow className={className}>
      {renderText(index)}
      <StyledTypeDescription>{text}</StyledTypeDescription>
      {children}
      {isReadOnly ? null : <DeleteButton id={index} onClick={onClickDelete} />}
    </StyledEntityRow>
  );
};

function renderText(index) {
  if (index === 0) {
    return <PaddedRowItem>If</PaddedRowItem>;
  }
  return <StyledRowItem>And</StyledRowItem>;
}

export default ConditionRow;
